// @flow
import React from 'react';
import classNames from 'classnames/bind';
import styles from './styles.scss';
import { getGivenBackground } from 'Utils/getColor';

const cx = classNames.bind(styles);

type Props = {
  children: Node,
  className?: string,
  background: string,
  footerMargin?: boolean,
  topMargin?: boolean,
  deeplinkId?: number,
};

export default class DefaultPage extends React.Component<Props> {
  static defaultProps = {
    background: getGivenBackground('medium'),
  };

  render() {
    const { children, className, background, footerMargin, topMargin, deeplinkId } = this.props;
    const rootClass = cx(className, background, {
      footerMargin: footerMargin,
      topMargin: topMargin,
    });

    return (
      <div className={rootClass} id={deeplinkId}>
        {children}
      </div>
    );
  }
}
